export const PILL_BUTTON_WEIGHTS = [
  'regular',
  'medium',
  'semibold',
  'bold',
] as const;
export const PILL_BUTTON_SIZES = ['sm', 'md'] as const;
export const PILL_BUTTON_VARIANTS = ['filled', 'outline', 'ghost'] as const;
export const PILL_BUTTON_COLORS = [
  'neutral',
  'primary',
  'secondary',
  'accent',
] as const;
export const PILL_BUTTON_ROUNDED = ['full', 'sm', 'none'] as const;
export const PILL_BUTTON_PADDINGS = ['sm', 'md', 'lg'] as const;
export const PILL_BUTTON_HOVERS = ['lighter', 'darker', 'none'] as const;

export type PillButtonWeight = (typeof PILL_BUTTON_WEIGHTS)[number];
export type PillButtonSize = (typeof PILL_BUTTON_SIZES)[number];
export type PillButtonVariant = (typeof PILL_BUTTON_VARIANTS)[number];
export type PillButtonColor = (typeof PILL_BUTTON_COLORS)[number];
export type PillButtonRounded = (typeof PILL_BUTTON_ROUNDED)[number];
export type PillButtonPadding = (typeof PILL_BUTTON_PADDINGS)[number];
export type PillButtonHover = (typeof PILL_BUTTON_HOVERS)[number];
